import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Icon, IconButton, Skeleton } from '@chakra-ui/react';
import { Text, Box, Flex, Spacer, Stack } from '@chakra-ui/layout';
import { MdAdd, MdShare } from 'react-icons/md';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/modal';
import { useDisclosure } from '@chakra-ui/react-use-disclosure';
import { MdArrowBack } from 'react-icons/md';
import SharedExperienceInExperienceListItem from './sharedExperienceInExperienceListItem';
import { ExperienceContext } from '../../lib/experienceContext';
import { ExperiencePageContext } from '../lib/experiencePageContext';
import useExperienceApi from '../../lib/useExperienceApi';
import { useNavigate } from 'react-router-dom';
import { useSharedExperiencesApi } from '../../../shared-experiences/lib/useSharedExperiencesApi';
import AddSharedExperienceToExperienceForm from './addSharedExperienceToExperienceForm';
import SharedExperienceForm from '../../../shared-experiences/components/sharedExperienceForm';

export default function SharedExperienceInExperienceList({ experienceId }) {
  const {
    rights,
  } = useContext(ExperienceContext);
  const {
    sharedExperienceList,
    isFetchingSharedExperienceList,
    refreshSharedExperienceList
  } = useContext(ExperiencePageContext);
  const experienceApi = useExperienceApi();
  const navigate = useNavigate();
  const sharedExperiencesApi = useSharedExperiencesApi();
  const [isAdding, setIsAdding] = useState(false);
  
  const modalAddSharedExperience = useDisclosure();
  const modalCreateSharedExperience = useDisclosure();
  const ref1 = useRef();
  const ref2 = useRef();

  const linkNewSharedExperienceToExperience = async (newSharedExperience) => {
    try {
      await sharedExperiencesApi.addExperience(newSharedExperience.id, experienceId);
      await refreshSharedExperienceList();
      setIsAdding(false);
      modalCreateSharedExperience.onClose();
      modalAddSharedExperience.onClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Box>
        <Flex
          alignItems='center'
          mb={1}
          px={3}
        >
          <Icon
            as={MdShare}
            color={'text.primary'}
            boxSize={'14px'}
            mr={2}
          />
          <Text fontSize={14}>Shared Experiences</Text>
          <Spacer />
          {rights.can_update && (
            <IconButton
              ml={2}
              variant="coralOutline"
              icon={<MdAdd />}
              onClick={modalAddSharedExperience.onOpen}
              size="sm"
            />
          )}
        </Flex>
        <Box maxH={300} overflowY={'auto'}>
          {isFetchingSharedExperienceList && (
            <Stack p={3} spacing={2} backgroundColor={'white'}>
              <Skeleton height='50px' />
              <Skeleton height='50px' />
              <Skeleton height='50px' />
            </Stack>
          )}
          {(!isFetchingSharedExperienceList && (!sharedExperienceList || sharedExperienceList.length === 0)) && (
            <Box px={3}>
              <Text color="text.light.grey" fontSize="12px">No shared experience so far.</Text>
            </Box>
          )}
          {(!isFetchingSharedExperienceList && sharedExperienceList) && sharedExperienceList.map((se, i) => {
            return (
              <Box
                key={i}
                style={{ 'cursor': 'pointer' }}
                onClick={() => {
                  navigate(`/shared-experiences/${se.shared_experiences?.id || se.id}`)
                }}
              >
                <SharedExperienceInExperienceListItem
                  sharedExperience={se}
                  onRemove={refreshSharedExperienceList}
                />
              </Box>
            );
          })}
        </Box>
      </Box>
      <Modal isOpen={modalAddSharedExperience.isOpen} onClose={modalAddSharedExperience.onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Shared Experiences</ModalHeader>
          <ModalBody>
            <Box p={3}>
              <AddSharedExperienceToExperienceForm
                experienceId={experienceId}
                hideSave={true}
                onCreateNew={() => {
                  modalAddSharedExperience.onClose();
                  modalCreateSharedExperience.onOpen();
                }}
                onSubmitted={refreshSharedExperienceList}
                ref={ref1}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='coralOutline'
              onClick={modalAddSharedExperience.onClose}
            >Close</Button>
            <Button
              variant="coralFill"
              ml={2}
              isLoading={isFetchingSharedExperienceList}
              onClick={() => {
                ref1.current.click();
                modalAddSharedExperience.onClose();
              }}>Save</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={modalCreateSharedExperience.isOpen} onClose={modalCreateSharedExperience.onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <IconButton
              fontSize='24'
              variant="tertiary"
              icon={<MdArrowBack />}
              aria-label='New'
              mr={2}
              onClick={() => {
                modalCreateSharedExperience.onClose();
                modalAddSharedExperience.onOpen();
              }}
            />
            New Shared Experience</ModalHeader>
          <ModalBody>
            <Box p={3}>
              <SharedExperienceForm
                hideSave={true}
                onSubmitted={(newSharedExperience) => {
                  linkNewSharedExperienceToExperience(newSharedExperience)
                }}
                ref={ref2}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='coralOutline'
              onClick={() => {
                modalCreateSharedExperience.onClose();
                modalAddSharedExperience.onOpen();
              }}
            >Close</Button>
            <Button
              variant="coralFill"
              ml={2}
              isLoading={isAdding}
              onClick={() => {
                setIsAdding(true)
                ref2.current.click();
              }}>Save</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
} 